<template>
  <div class="wpop-cover">
    <div class="wpop-wrapper">
      <i class="wpop-close" @click="$emit('close')"></i>
      <div class="wpop-wrapper__title">
        <slot name="title">
          <h3>{{ title }}</h3>
        </slot>
      </div>
      <div class="wpop-wrapper__content">
        <slot></slot>
      </div>
      <div class="wpop-wrapper__footer">
        <slot name="footer">
          <button
            class="wpop-wrapper__footer-confirm"
            @click="$emit('confirm')"
          >
            {{ btnTxt }}
          </button>
          <button
            v-if="cancelBtnTxt"
            class="wpop-wrapper__footer-cancel"
            @click="$emit('cancel')"
          >
            {{ cancelBtnTxt }}
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    btnTxt: {
      type: String,
      default: '确认'
    },
    cancelBtnTxt: {
      type: String,
      default: '取消'
    }
  }
}
</script>
